export var ColorMode;
(function (ColorMode) {
    ColorMode["LIGHT"] = "light";
    ColorMode["DARK"] = "dark";
})(ColorMode || (ColorMode = {}));
//# sourceMappingURL=ColorMode.js.map